import store from "../store"
import APP from "../main"
/**
 * 保存VueX数据到sesstion
 * @sesstionName 保存到sesstion的名称
 */

let SESSTIONNAME = ""
export const saveStoreToSesstion = (sesstionName) => {
    SESSTIONNAME = sesstionName;
    const str = sessionStorage.getItem(sesstionName)
    if (str) {
        try {
            const state = JSON.parse(str)
            store.replaceState(state)
        } catch (e) {
            throw new Error("Save Vuex.store state error");
        }
    }


    window.onbeforeunload = () => {
        sessionStorage.setItem(sesstionName, JSON.stringify(store.state))
    }
}
/**
 * 删除Sesstion的数据,不然只清空Vuex的数据没有用
*/
export const deleteStoreToSesstion = () => {
    sessionStorage.removeItem(SESSTIONNAME);
}

// /**
//  * 判断登陆状态的方法，全局的登陆状态都依赖此方法
// */
// export const getuserLoginState = () => {

//     const USER = APP.$store.state.user;
//     console.log('USER:', USER)
//     if (USER.password.trim() === '') {
//         return false;
//     }
//     if (USER.username.trim() === '') {
//         return false;
//     }
//     if (USER.token.trim() === '') {
//         return false;
//     }
//     if (USER.userid === 0) {
//         return false;
//     }

//     return true;
// }


